/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".upload-file-cover{display:-webkit-box;display:-ms-flexbox;display:flex;cursor:pointer}.upload-file-cover .input-wrap{width:440px}.upload-file-cover ig-button{margin:9px auto auto 8px;height:32px}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/file.selector/file.selector.component.scss.ngstyle.js.pre-build-optimizer.js